import invert from 'lodash/invert'
import { CURATOR_MENU_SECTION } from "../../redux/slicers/admin/curatorMenuPreferencesSlicer";

export const MAX_RESOLUTION = 4000;
export const MIN_RESOLUTION = 1;

export const TEXTURE_MAP = {
  DIFFUSE:            0,  // for Select texture from gallery
  NORMAL:             1,  // for custom normal map
  ROUGHNESS:          2,  // for custom roughness map
  AMBIENTOCCLUSION:   3,  // for custom ocullsion map
  TRANSPARENCY:       4 , // for custom transparency map
  METALLIC:           5,  // for custom metallic map
  DISPLACEMENT:       6   // for custom displacement map
}

export const TILING_TYPE = {
  TEXTURE: 0, // for texture tiling  
  MATERIAL: 1, 
  DEPTH: 2, // for normal tiling
  GLOSSY: 3, // for Glossy tiling
  TRANSPARENCY: 4, // for Transparency tiling
  AO: 5,
  METALLIC: 6,
  EMISSION: 999, // TODO: what is the real number of emission???
  OTHER: 1000,
  CLEARCOAT: 1001,
  DISPLACEMENT: 7,
  TUFT_DISPLACEMENT: 8
}

export const GENERATE_MAP_TYPE = {
  [TILING_TYPE.DEPTH]: 'normal',
  [TILING_TYPE.AO]: 'ambientOcclusion',
  [TILING_TYPE.GLOSSY]: 'roughness',
}

export const TILING_TYPE_LABEL = {
  [TILING_TYPE.TEXTURE]: 'texture',
  [TILING_TYPE.MATERIAL]: 'material',
  [TILING_TYPE.DEPTH]: 'depth (normal)',
  [TILING_TYPE.GLOSSY]: 'glossy',
  [TILING_TYPE.TRANSPARENCY]: 'transparency',
  [TILING_TYPE.AO]: 'ambient occlusion',
  [TILING_TYPE.METALLIC]: 'metallic',
  [TILING_TYPE.CLEARCOAT]: 'clearcoat',
  [TILING_TYPE.DISPLACEMENT]: 'displacement',
}

export const CHANGED_MAP_PATHS_MAP = {
  texture: 'diffuseId',
  glossiness: 'roughnessId',
  normal: 'normalId',
  transparency: 'transparencyId',
  ao: 'AOId',
  metallic: "metallicId",
  displcement: "displacementId"
}

export const CHANGED_MAP_IDS__TEXTURE_MAP = {
  [TEXTURE_MAP.DIFFUSE]: 'diffuseId',
  [TEXTURE_MAP.NORMAL]: 'normalId',
  [TEXTURE_MAP.ROUGHNESS]: 'roughnessId',
  [TEXTURE_MAP.TRANSPARENCY]: 'transparencyId',
  [TEXTURE_MAP.METALLIC]: 'metallicId',
  [TEXTURE_MAP.AMBIENTOCCLUSION]: 'AOId',
  [TEXTURE_MAP.DISPLACEMENT]: 'displacementId',
}
export const CHANGED_MAP_PATHS__TEXTURE_MAP = {
  [TEXTURE_MAP.DIFFUSE]: 'diffusePath',
  [TEXTURE_MAP.NORMAL]: 'normalPath',
  [TEXTURE_MAP.ROUGHNESS]: 'roughnessPath',
  [TEXTURE_MAP.TRANSPARENCY]: 'transparencyPath',
  [TEXTURE_MAP.METALLIC]: 'metallicPath',
  [TEXTURE_MAP.AMBIENTOCCLUSION]: 'AOPath',
  [TEXTURE_MAP.DISPLACEMENT]: 'displacementPath',
}

export const TEXTURE_NAME_KEY = {
  DIFFUSE: 'diffuseName',
  NORMAL: 'normalMapName',
  ROUGHNESS: 'roughnessMapName',
  TRANSPARENCY: 'transparencyMapName',
  METALLIC: 'metallicMapName',
  AO: 'aoMapName',
  DISPLACEMENT: 'displacementMapName'
}

export const TEXTURE_MAP__TEXTURE_NAME_KEY = {
  [TEXTURE_MAP.DIFFUSE]: TEXTURE_NAME_KEY.DIFFUSE,
  [TEXTURE_MAP.NORMAL]: TEXTURE_NAME_KEY.NORMAL,
  [TEXTURE_MAP.ROUGHNESS]: TEXTURE_NAME_KEY.ROUGHNESS,
  [TEXTURE_MAP.TRANSPARENCY]: TEXTURE_NAME_KEY.TRANSPARENCY,
  [TEXTURE_MAP.METALLIC]: TEXTURE_NAME_KEY.METALLIC,
  [TEXTURE_MAP.AMBIENTOCCLUSION]: TEXTURE_NAME_KEY.AO,
  [TEXTURE_MAP.DISPLACEMENT]: TEXTURE_NAME_KEY.DISPLACEMENT,
}

export const TEXTURE_NAME_KEY__TEXTURE_MAP = invert(TEXTURE_MAP__TEXTURE_NAME_KEY);



export const DIMENSION = {
  _2D: '2D',
  _3D: '3D',
}

export const UNITY_2D_VIEW_MODE = {
  TOP: 0,
  LEFT: 1,
  RIGHT: 2,
  FRONT: 3,
  BACK: 4,
}

export const CURSOR_MODE = {
  MOVE: 'MOVE',
  ROTATE: 'ROTATE',
  SCALE: 'SCALE',
  STYLE_ONLY: 'STYLE_ONLY',
}

export const TRANSFORM_SPACE_MODE = {
  GLOBAL: 0,
  LOCAL: 1,
}

export const MEASURE_UNIT = {
  INCHES: 1,
  FEET: 2,
  CM: 3,
  METER: 4,
}

export const CONVERT_TO_CM = 30.48;
export const CM_IN_ONE_INCHES = 2.54;

export const MEASURE_UNIT_NAME = {
  INCHES: 'INCHES',
  FEET: 'FEET',
  CM: 'CM',
  METER: 'METER',
}

export const MEASURE_UNIT_LABEL = {
  INCHES: 'inches',
  FEET: 'feet',
  CM: 'cm',
  METER: 'meter',
}

export const MEASURE_UNIT_NAME_MAP = {
  [MEASURE_UNIT.INCHES]: MEASURE_UNIT_NAME.INCHES,
  [MEASURE_UNIT.FEET]: MEASURE_UNIT_NAME.FEET,
  [MEASURE_UNIT.CM]: MEASURE_UNIT_NAME.CM,
  [MEASURE_UNIT.METER]: MEASURE_UNIT_NAME.METER,
}


export const AXIS = {
  X: 'X',
  Y: 'Y',
  Z: 'Z',
  ALL: 'All',
}

export const ROTATE_MODE = {
  GLOBAL: 'GLOBAL',
  X: 'X',
  Y: 'Y',
  Z: 'Z',
}

export const DECIMAL_NUM_COUNT = 2;

export const TILING_TEXTURE_MAP = {
  [TILING_TYPE.TEXTURE]: TEXTURE_MAP.DIFFUSE,
  [TILING_TYPE.DEPTH]: TEXTURE_MAP.NORMAL,
  [TILING_TYPE.GLOSSY]: TEXTURE_MAP.ROUGHNESS,
  [TILING_TYPE.TRANSPARENCY]: TEXTURE_MAP.TRANSPARENCY,
  [TILING_TYPE.METALLIC]: TEXTURE_MAP.METALLIC,
  [TILING_TYPE.AO]: TEXTURE_MAP.AMBIENTOCCLUSION,
  [TILING_TYPE.DISPLACEMENT]: TEXTURE_MAP.DISPLACEMENT,
}

export const TEXTURE_MAP_TO_TILING_TYPE = invert(TILING_TEXTURE_MAP);

export const TILING_KEY = {
  _MainTex: '_MainTex',
  _SmoothnessMap: '_SmoothnessMap', // rougness
  _BumpMap: '_BumpMap',
  _AlphaTexture: '_AlphaTexture', // transparency
  _OcclusionMap: '_OcclusionMap',
  _MetallicGlossMap: '_MetallicGlossMap',
  _DisplacementMap: '_DisplacementMap'
}

export const TILING_MAP = {
  [TILING_TYPE.TEXTURE]: "_MainTex",
  [TILING_TYPE.GLOSSY]: "_SmoothnessMap",
  [TILING_TYPE.DEPTH]: "_BumpMap",
  [TILING_TYPE.TRANSPARENCY]: "_AlphaTexture",
  [TILING_TYPE.AO]: "_OcclusionMap",
  [TILING_TYPE.METALLIC]: "_MetallicGlossMap",
  [TILING_TYPE.DISPLACEMENT]: "_DisplacementMap"
};

export const OBJECT_MOVE_MAX_METERS = 100; // when user selects single axis -> it's max he can move that object

export const TILING_NAME_MAP = {
  [TILING_TYPE.TEXTURE]: "texture",
  [TILING_TYPE.MATERIAL]: "material",
  [TILING_TYPE.DEPTH]: "normal",
  [TILING_TYPE.GLOSSY]: "glossiness",
  [TILING_TYPE.TRANSPARENCY]: "transparency",
  [TILING_TYPE.AO]: "ao",
  [TILING_TYPE.METALLIC]: "metallic",
  [TILING_TYPE.EMISSION]: "emission",
  [TILING_TYPE.CLEARCOAT]: "clearcoat",
  [TILING_TYPE.DISPLACEMENT]: "displacement",
  [TILING_TYPE.OTHER]: "other",
}

export const RAW_MAP_KEY_NAME = {
  [TILING_TYPE.DEPTH]: "normalMapName",
  [TILING_TYPE.GLOSSY]: "roughnessMapName",
  [TILING_TYPE.TRANSPARENCY]: "transparencyMapName",
  [TILING_TYPE.AO]: "aoMapName",
  [TILING_TYPE.METALLIC]: "metallicMapName",
  [TILING_TYPE.DISPLACEMENT]: "displacementMapName"
}

export const REVERSE_TILING_MAP = invert(TILING_MAP)

export const PROPERTY_MAP = {
  texture: "_MainTex",
  glossiness: "_SmoothnessMap",
  normal: "_BumpMap",
  transparency: "_AlphaTexture",
  ao: "_OcclusionMap",
  metallic: "_MetallicGlossMap",
  displacement: "_DisplacementGlossMap",
};

export const REVERSE_PROPERTY_MAP = invert(PROPERTY_MAP);

export const SELECTED_OBJECT_COUNT_STR = {
  NONE: 'NoneObject',
  SINGLE: 'SingleObject',
  MULTIPLE: 'MultipleObject',
}

export const UNITY_OBJECT_TYPE = {
  PROP: 'Prop',
  LIGHT: 'Light',
}

export const RP_TYPE = {
  RENDER: 'RENDER', // HIGH RESOLUTION / PREMIUM LICENSE
  PREVIEW: 'PREVIEW', // QUICK VIEW / NON COMMERCIAL LICENSE
  AUTOMATION: 'AUTOMATION',
};

export const DEFAULT_CAMERA_BLUR_INTENSITY = 5; // when we select object this blur intensity is applied by default in unity so we need to reset camera blur intensity to this value

export const HIDDEN_SECTIONS = [CURATOR_MENU_SECTION.MORE];

export const OBJECT_SELECTION_MODE = {
  STYLE: 'Style',
  TRANSFORM: 'Transform',
}

export const QUAILTY = {
  FANTASTIC: 0,
  GOOD: 1,
  PERFORMANCE: 2,
}

export const QUALITY_ID = {
  FANTASTIC: 1,
  GOOD: 2,
  SIMPLE: 3,
  PERFORMANCE: 4,
}

export const DEFAULT_QUAILTY_ID = QUALITY_ID.GOOD;
export const DEFAULT_DPR = 1.25;


export const QUALITY_ID_TO_QUALITY = {
  [QUALITY_ID.FANTASTIC]: QUAILTY.FANTASTIC,
  [QUALITY_ID.GOOD]: QUAILTY.GOOD,
  [QUALITY_ID.PERFORMANCE]: QUAILTY.PERFORMANCE,
}

export const QUAILTY_TO_DPR = {
  [QUAILTY.FANTASTIC]: 1.5,
  [QUAILTY.GOOD]: 1.25,
  [QUAILTY.PERFORMANCE]: 1,
}


export const SHORTCUT_TYPE = {
  BASIC: 'Basic',
  VIEWPORT: 'Viewport',
  EDIT: 'Edit',
  TOOLS: 'Tools',
  SELECTION: 'Selection',
  VIEW: 'View',
};

export const SHORTCUT_TYPE_MATTRESS_BUILDER = {
  BASIC: 'Basic',
  VIEWPORT: 'Viewport',
  EDIT: 'Edit',
  SELECTION: 'Selection',
};


export const SELECTED_OBJECT_TYPE = {
  LAYOUT: 'Layout',
}

export const GLOSSY_MIN = 0;
export const GLOSSY_MAX = 1;

export const DEPTH_MIN = 0;
export const DEPTH_MAX = 1.5;

export const TRANSPARENCY_MIN = 0;
export const TRANSPARENCY_MAX = 1;

export const METALLIC_MIN = 0;
export const METALLIC_MAX = 1;

export const AO_MIN = 0;
export const AO_MAX = 1;

export const EMISSION_MIN = 0;
export const EMISSION_MAX = 1;
export const EMISSION_NEW_MAX = 200;

export const HDRI_MIN_INTENSITY = 0;
export const HDRI_MAX_INTENSITY = 5;

export const HDRI_MIN_ROTATION = 0;
export const HDRI_MAX_ROTATION = 359;

export const LIGHT_MIN_INTENSITY = 0;
export const LIGHT_MAX_INTENSITY = 10;

export const CLEARCOAT_MIN = 0;
export const CLEARCOAT_MAX = 1;

export const SPECULATION_STATUS = {
  UNDEFINED: 0,
  ON: 1, 
  OFF: 2
}